import React, { useContext } from 'react';
import LoadingOverlay from "../LoadingOverlay.js";
import { FontsLoadedContext } from "./FontBootstrap.js";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function FontsLoaded(_ref) {
  var children = _ref.children;
  var isFontsLoaded = useContext(FontsLoadedContext);
  if (!isFontsLoaded) {
    return /*#__PURE__*/_jsx(LoadingOverlay, {
      "data-testid": "fonts-loaded-loading"
    });
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
}
export default FontsLoaded;
//# sourceMappingURL=FontsLoaded.js.map